




import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';

const Component = defineComponent({
  name: 'FontGroupsTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.FONT_GROUP;

    const state = reactive({
      headers: [
        { text: 'Name', value: 'name', sortable: true, searchable: true },
        { text: 'Fonts amount', value: 'totalFonts', align: 'center', sortable: false },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
    };
  },
});
export default Component;
